import { FC } from "react";
import { TabsProps } from "antd";
import { TableTabsStyles } from "./styles";

export const TableTabs: FC<TabsProps> = (props) => {
  return <TableTabsStyles {...props} />;
};
